import { useEffect, useRef } from 'react';
import { IUseTableResetTableMethodsReturn, IUseTableReturn } from '../../useTable';
import { IUseTableFetchReturn } from '../../useTableFetch';

interface IUseTablePreserverActivePageValidatorProps extends
  Pick<IUseTableReturn<object>, 'activePage' | 'perPage'>,
  Pick<IUseTableResetTableMethodsReturn, 'resetActivePage'>,
  Pick<IUseTableFetchReturn<unknown>, 'total' | 'isFetchedAfterMount'> {}

const useTablePreserverActivePageValidator = (
  props: IUseTablePreserverActivePageValidatorProps,
) => {
  const {
    activePage, resetActivePage, perPage, total, isFetchedAfterMount,
  } = props;

  const isInitialized = useRef(false);

  useEffect(() => {
    if (isInitialized.current || !isFetchedAfterMount) {
      return;
    }
    isInitialized.current = true;
    if (activePage > Math.ceil(total / perPage)) {
      resetActivePage();
    }
  }, [activePage, resetActivePage, perPage, isFetchedAfterMount, total]);
};

export default useTablePreserverActivePageValidator;
